import {createSlice, isAnyOf} from '@reduxjs/toolkit';

import {extendedAPI} from './api';

import {LaneSerializedType} from 'sweet-types';

export interface LanesState {
  byId: {[id: string]: LaneSerializedType};
}

const initialState: LanesState = {
  byId: {},
};

const lanesSlice = createSlice({
  name: 'lanes',
  initialState,
  reducers: {},
  extraReducers: (builder) =>
    builder
      .addMatcher(
        isAnyOf(
          extendedAPI.endpoints.lanes.matchFulfilled,
          extendedAPI.endpoints.lanesForDocument.matchFulfilled
        ),
        (state, {payload: {results}}) => {
          // store all fetched lanes into lanes.byId
          for (const lane of results) {
            state.byId[lane.hashid] = lane;
          }
        }
      )
      .addMatcher(
        extendedAPI.endpoints.createLane.matchFulfilled,
        (state, {payload: lane}) => {
          state.byId[lane.hashid] = lane;
        }
      )
      .addMatcher(
        extendedAPI.endpoints.updateLane.matchFulfilled,
        (state, {payload: lane}) => {
          state.byId[lane.hashid] = lane;
        }
      )
      .addMatcher(
        extendedAPI.endpoints.deleteLane.matchFulfilled,
        (state, {meta}) => {
          // when a lane is deleted, remove it from the state so it will disappear
          // from all steps using it
          delete state.byId[meta.arg.originalArgs];
        }
      ),
});

export const lanesReducer = lanesSlice.reducer;
